import Vue from 'vue'
import VueRouter from 'vue-router'

import Dashboard from '../views/DashboardPage.vue'
import HomeDashboard from '../views/HomeDashboard.vue'
import WalletPage from '../views/WalletPage.vue'
import AdminWalletPage from '../views/AdminWalletPage.vue'
import ApprovedAccounts from '../views/ApprovedAccounts.vue'

// SIGNUP PAGE
//import SigninPage from '../views/SigninPage.vue'
import GenerateAccount from '../views/GenerateAccount.vue'
import RegisteredFarmers from '../views/RegisteredFarmers.vue'
import FarmersPage from '../views/FarmersPage.vue'
import LandPage from '../views/LandPage.vue'
import LoginPage from '../views/LoginPage.vue'


Vue.use(VueRouter)

// parse jwt token
function parseJwt (token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

function beforeRouteEnter (to, from, next) {
  try{
  if (localStorage.getItem('wertyuiojhdfghhdrtfyguh')) {
    const jwtPayload = parseJwt(localStorage.getItem('wertyuiojhdfghhdrtfyguh'));
    if (jwtPayload.exp < Date.now() / (1000 * 60)) {
        // token expired
        //deleteTokenFromLocalStorage();
        next("/login");
    }
    next();
  } else {
    next("/login");
  }
  }catch (err) {
    console.log(err);
  }
}

const routes = [

  {
    path: '/',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    props: true,
    meta: {
      secure:false,
    },
    
    children: [
      {
        path: '/home',
        name: 'HomeDashboard',
        //beforeEnter : beforeRouteEnter,
        component: HomeDashboard,
        meta: {
          secure:true,
        }
      },  
      {
        path: '/accounts',
        name: 'GenerateAccount',
       // beforeEnter : beforeRouteEnter,
        component: GenerateAccount,
        meta: {
          secure:true,
        }
      }, 
      {
        path: '/wallet',
        name: 'WalletPage',
        //beforeEnter : beforeRouteEnter,
        component: WalletPage,
        meta: {
          secure:true,
        }
      },  

      {
        path: '/admin-wallet',
        name: 'AdminWalletPage',
        //beforeEnter : beforeRouteEnter,
        component: AdminWalletPage,
        meta: {
          secure:true,
        }
      },  

      {
        path: '/approved-accounts',
        name: 'ApprovedAccounts',
        //beforeEnter : beforeRouteEnter,
        component: ApprovedAccounts,
        meta: {
          secure:true,
        }
      },  

      {
        path: '/registered-farmers',
        name: 'RegisteredFarmers',
        //beforeEnter : beforeRouteEnter,
        component: RegisteredFarmers,
        meta: {
          secure:true,
        }
      }, 
      
      {
        path: '/farmers',
        name: 'FarmersPage',
        //beforeEnter : beforeRouteEnter,
        component: FarmersPage,
        meta: {
          secure:true,
        }
      }, 

      {
        path: '/lands',
        name: 'LandPage',
        //beforeEnter : beforeRouteEnter,
        component: LandPage,
        meta: {
          secure:true,
        }
      }, 
      
    ]
  },
 
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
